import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getGroups, getUsers } from "../actions/auth.js"
import Select_Dsas from "./Select_Dsas.js"

const FilterUser = ({classname, labelId, label, selectId, name, filters, setFilters, handleFilter = () => {}, mandatory}) => {

    const dispatch = useDispatch()

    const users = useSelector((state) => state.authentication).users

    useEffect(() => {
        dispatch(getUsers())
    }, [])
//`${classes.root} ${classes.form}`
    return (
    <Select_Dsas 
        className={classname}
        labelId = {labelId}
        label = {label}
        selectId = {selectId}
        name = {name}
        value = {filters.userNames}
        isError={(mandatory && (!filters.userNames || filters.userNames.length === 0)) ? true : false}
        items = {users.filter(handleFilter)}
        onChange = {(e) => setFilters(state => ({...state, [name] : e.target.value}))}
        onReset = {(e) => setFilters(state => ({...state, [name] : ''}))}>
    </Select_Dsas>)

}

export default FilterUser